import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonInput from "components/ArgonInput";
import ArgonButton from "components/ArgonButton";
import rocketImage from "assets/images/rocket.svg";
import emailVerificationImage from "assets/images/email-verification-bg.svg";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { useEffect, useRef, useState } from "react";
import { resetPassword, verifyOtp } from "services/authService";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";

function Cover() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (!email) {
      navigate("/user/reset-password");
    }
  }, [email, navigate]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleVerifyOtp = () => {
    if (otp.length !== 4 || otp.includes("")) {
      toast.error("Invalid OTP");
      return;
    }
    const otpString = otp.join("");
    const code = otpString.split("").reverse().join("");

    verifyOtp(email, code)
      .then((res) => {
        toast.success("OTP verified successfully");
        navigate(
          `/user/update-password?email=${encodeURIComponent(email)}&otp=${code}`
        );
      })
      .catch((err) => {
        toast.error("Invalid OTP");
      });
  };

  const handleResendOtp = () => {
    resetPassword(email)
      .then((data) => {
        toast.success("Check your inbox for OTP");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong");
      });
  };

  return (
    <CoverLayout image={emailVerificationImage} button={{ color: "warning" }}>
      <Card>
        <ArgonBox textAlign="center" p={6}>
          <ArgonBox display="flex" justifyContent="center">
            <img src={rocketImage} alt="rocket" />
          </ArgonBox>
          <ArgonBox mb={3} px={1}>
            <ArgonTypography variant="h2" fontWeight="bold">
              Email Verification
            </ArgonTypography>
          </ArgonBox>
          <ArgonBox mb={2}>
            <Grid container spacing={2}>
              <Grid item xs>
                <ArgonInput
                  size="large"
                  inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                  value={otp[3]}
                  onChange={(e) => handleChange(3, e)}
                  onKeyDown={(e) => handleKeyDown(3, e)}
                  inputRef={(el) => (inputRefs.current[3] = el)}
                />
              </Grid>
              <Grid item xs>
                <ArgonInput
                  size="large"
                  inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                  value={otp[2]}
                  onChange={(e) => handleChange(2, e)}
                  onKeyDown={(e) => handleKeyDown(2, e)}
                  inputRef={(el) => (inputRefs.current[2] = el)}
                />
              </Grid>
              <Grid item xs>
                <ArgonInput
                  size="large"
                  inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                  value={otp[1]}
                  onChange={(e) => handleChange(1, e)}
                  onKeyDown={(e) => handleKeyDown(1, e)}
                  inputRef={(el) => (inputRefs.current[1] = el)}
                />
              </Grid>
              <Grid item xs>
                <ArgonInput
                  size="large"
                  inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                  value={otp[0]}
                  onChange={(e) => handleChange(0, e)}
                  onKeyDown={(e) => handleKeyDown(0, e)}
                  inputRef={(el) => (inputRefs.current[0] = el)}
                />
              </Grid>
            </Grid>
          </ArgonBox>
          <ArgonBox mb={2}>
            <ArgonButton color="primary" fullWidth onClick={handleVerifyOtp}>
              Verify
            </ArgonButton>
          </ArgonBox>
          <ArgonTypography variant="button" color="text" fontWeight="regular">
            Haven&apos;t received it?{" "}
            <ArgonTypography
              component="a"
              variant="button"
              onClick={handleResendOtp}
              sx={{ cursor: "pointer" }}
            >
              Resend a new code
            </ArgonTypography>
            .
          </ArgonTypography>
        </ArgonBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
